module.exports = __webpack_public_path__ + "static/media/header.8311c714.png";